import { Grid } from '@mui/material';
import { styles } from './styles';

export const DraftCardCount = ({ count }: { count: number }) => {
  return <Grid sx={styles.count}>{count}</Grid>;
};
